interface RuntimeAuthSession {
  token: string | null;
  activeWorkspaceId: string | null;
}

let runtimeSession: RuntimeAuthSession = {
  token: null,
  activeWorkspaceId: null,
};

export function setRuntimeAuthSession(session: RuntimeAuthSession): void {
  runtimeSession = { ...session };
}

export function setRuntimeActiveWorkspaceId(activeWorkspaceId: string | null): void {
  runtimeSession = { ...runtimeSession, activeWorkspaceId };
}

export function getRuntimeAuthSession(): RuntimeAuthSession {
  return { ...runtimeSession };
}
